import { LineWithFlag } from "@/playground/components/DevHome/table/components/LineWithFlag/LineWithFlag";
import type { NumberRowType } from "@/playground/components/DevHome/table/pages/conversation_center/components/Table/Table.decl";
import { HeaderSimple } from "../../../pages/conversation_center/components/HeaderSimple/HeaderSimple";
import type { ColumnType } from "../columns.decl";

export const numberConfig: ColumnType = {
  id: "number",
  label: <HeaderSimple label="number" />,
  renderer: (_, value: NumberRowType) => {
    if (!value || !value.name || !value.countryISOCode) {
      return null;
    }

    const { name, countryISOCode, phoneNumber } = value;

    return (
      <div
        className="w-[175px] min-[1440px]:w-[210px]"
        data-test="line-with-flag-container"
      >
        <LineWithFlag
          name={name}
          countryISO={countryISOCode}
          phoneNumber={phoneNumber}
        />
      </div>
    );
  },
};
